import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

import React, { createContext, useEffect, useState } from 'react';
import { get, post } from '../lib/api';
export var Context = createContext(undefined);
export var Provider = function Provider(_ref) {
  var _ref$value = _ref.value,
      apiHost = _ref$value.apiHost,
      organizationId = _ref$value.organizationId,
      children = _ref.children;

  var _useState = useState({}),
      config = _useState[0],
      setConfig = _useState[1];

  var getConfig = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$get, data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return get(apiHost, '/api/config', {
                organizationId: organizationId
              });

            case 2:
              _yield$get = _context.sent;
              data = _yield$get.data;
              return _context.abrupt("return", data);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getConfig() {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    getConfig().then(function (config) {
      setConfig(config);
    });
  }, []);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: {
      apiHost: apiHost,
      organizationId: organizationId,
      config: config
    }
  }, children);
};